<template>
    <div v-if="loading == false">
        <div class="container-fluid">
            <div class="p-3 pb-0 mb-5 text-center" v-if="stoplist.type == 0 || (stoplist.type == 1 && stoplistIsText == false)">
                <h3 class="mb-3">
                    <a :href="'/instruments/'+stoplist.instruments[0].id" target="_blank" class="text-decoration-none text-dark">
                        {{ stoplist.instruments[0].builder.name }} <span v-if="stoplist.instruments[0].opus || stoplist.instruments[0].year">(</span><span v-if="stoplist.instruments[0].opus">Opus <span v-if="stoplist.instruments[0].opusPrefix">{{ stoplist.instruments[0].opusPrefix }}</span>{{ stoplist.instruments[0].opus}}<span v-if="stoplist.instruments[0].opusSuffix">{{ stoplist.instruments[0].opusSuffix }}</span><span v-if="stoplist.instruments[0].year">, </span></span><span v-if="stoplist.instruments[0].year"><span v-if="stoplist.instruments[0].yearPrefix">{{ stoplist.instruments[0].yearPrefix }}</span>{{ stoplist.instruments[0].year }}<span v-if="stoplist.instruments[0].yearSuffix">{{ stoplist.instruments[0].yearSuffix }}</span></span><span v-if="stoplist.instruments[0].opus || stoplist.instruments[0].year">)</span>
                    </a>
                </h3>
                <h4><a :href="'/locations/'+stoplist.instruments[0].location.id" target="_blank" class="text-decoration-none text-dark"><b>{{stoplist.instruments[0].location.name}} <span v-if="stoplist.instruments[0].room">({{stoplist.instruments[0].room}})</span></b></a></h4>
                <h4><small><span v-if="stoplist.instruments[0].location.city || stoplist.instruments[0].location.neighborhood">{{ stoplist.instruments[0].location.city }}<span v-if="stoplist.instruments[0].location.neighborhood"> ({{stoplist.instruments[0].location.neighborhood}})</span>,</span> <span v-if="stoplist.instruments[0].location.state">{{ stoplist.instruments[0].location.state }},</span> <span v-if="stoplist.instruments[0].location.country">{{ stoplist.instruments[0].location.country }}</span></small></h4>
            </div>
            <div class="row stoplistView justify-content-center" v-if="stoplist.type == 0">
                <div class="col-12 col-md-6 col-xl-4 mb-5 stoplistRow" v-for="division in stoplistDivisions" :key="division.id">
                    <table class="table table-borderless w-100" style="margin: 0 auto;">
                        <tbody>
                            <tr class="dropdown stopItem">
                                <td class="pb-1 pt-0 text-end" style="width: 15% !important;"></td>
                                <td class="pb-1 pt-0 divisionName" style="width: 60% !important;" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i>
                                        <b class="text-uppercase">{{division.name}}</b><span v-if="division.keyboard || division.isEnclosed == 1"> (</span><span v-if="division.keyboard">{{toRoman(division.keyboard)}}</span><span v-if="division.keyboard && division.isEnclosed == 1"> - </span><span v-if="division.isEnclosed == 1">Expressive</span><span v-if="division.keyboard || division.isEnclosed == 1">)</span>
                                    </i>
                                </td>
                                <ul class="dropdown-menu stoplistDropdown">
                                    <li v-if="division.position"><b>Position</b>: {{divisionPositionTypeOptions[division.position]}}</li>
                                    <li v-if="division.chestActionType"><b>Chest Action</b>: {{divisionChestActionTypeOptions[division.chestActionType]}}</li>
                                    <li v-if="division.stopActionType"><b>Stop Action</b>: {{divisionStopActionTypeOptions[division.stopActionType]}}</li>
                                    <li v-if="division.notes"><b>Notes</b>: {{division.notes}}</li>
                                </ul>
                            </tr>
                            <tr v-for="stop in division.stops" :key="stop.id" class="dropdown stopItem">
                                <td class="pb-1 pt-0 text-end" v-if="stop.length">{{stop.length}}<span v-if="(stop.numRanks && stop.numRanks < 2) || parseInt(stop.length)">'</span></td>
                                <td class="pb-1 pt-0 text-end" v-if="stop.length == null || stop.length == ''"></td>
                                <td class="pb-1 pt-0 stopName" data-bs-toggle="dropdown" aria-expanded="false">
                                    <b :class="{'cR4': stop.isReed == 1}">{{stop.name}}</b>
                                </td>
                                <td class="pb-1 pt-0 pl-5 text-end" v-if="stop.isPrepared == 0 && stop.isDigital == 0">{{stop.pipes}} <i v-if="stop.extendedFrom">{{stop.extendedFrom}}</i></td>
                                <td class="pb-1 pt-0 pl-5 text-end" v-if="stop.isPrepared == 0 && stop.isDigital == 1">DIG <i v-if="stop.extendedFrom">{{stop.extendedFrom}}</i></td>
                                <td class="pb-1 pt-0 pl-5 text-end" v-if="stop.isPrepared == 1">PF</td>
                                <ul class="dropdown-menu stoplistDropdown">
                                    <li v-if="stop.windPressure"><b>Wind Pressure</b>: {{ stop.windPressure }}"</li>
                                    <li v-if="stop.notes"><b>Notes</b>: {{stop.notes}}</li>
                                </ul>
                            </tr>
                            <tr v-if="division.couplers.length > 0" class="stopItem">
                                <td class="pb-2"></td>
                            </tr>
                            <tr v-for="coupler in division.couplers" :key="coupler.id" class="dropdown stopItem">
                                <td class="pb-1 pt-0 text-end"><span v-if="!coupler.altName && !coupler.isUnisonOff == 1">{{coupler.length}}'</span></td>
                                <td class="pb-1 pt-0 stopName" data-bs-toggle="dropdown" aria-expanded="false"><span v-if="coupler.altName">{{ coupler.altName }}</span><span v-else><span v-if="!coupler.isUnisonOff == 1">{{coupler.from}} to </span>{{coupler.to}}<span v-if="coupler.isUnisonOff == 1"> Unison Off</span></span></td>
                                <td class="pb-1 pt-0 pl-5 text-end"></td>
                                <ul class="dropdown-menu stoplistDropdown">
                                    <li v-if="coupler.altName"><span v-if="coupler.isUnisonOff != 1">{{coupler.length}}' {{coupler.from}} to </span>{{coupler.to}}<span v-if="coupler.isUnisonOff == 1"> Unison Off</span></li>
                                    <li v-if="coupler.notes"><b>Notes</b>: {{coupler.notes}}</li>
                                </ul>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="stoplist.type == 1 && stoplistIsText == true">
                <pre>{{ textFileContent }}</pre>
            </div>
            <div v-if="stoplist.type == 1 && stoplistIsText == false">
                <iframe v-bind:src="apiEndpoint + '/uploads/stoplists/' + stoplist.filename" frameborder="0" class="w-100" style="width: 100% !important; min-height: 75vh; overflow: auto; white-space: nowrap;"></iframe>
            </div>
        </div>
    </div>
    <div v-if="loading == true" class="mt-5 text-center">
        <h1 class="d-inline-block me-3">Loading...</h1>
        <div class="spinner-border text-secondary d-inline-block" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script>
    import StoplistService from "../services/stoplist.service";
    import moment from "moment";
    import axios from "axios";
    import ItemTypes from "../itemTypes";

    export default {
        name: "Stoplist",
        computed: {
            apiEndpoint() {
                return process.env.VUE_APP_API_ENDPOINT;
            },
            currentUser() {
                return this.$store.state.auth.user;
            },
            loggedIn() {
                return this.$store.state.auth.status.loggedIn;
            }
        },
        metaInfo() {
            return {
                title: this.metaTitle ? this.metaTitle + ' | Pipe Organ Database' : 'Stoplist Details | Pipe Organ Database',
                meta: [
                    {
                        property: 'og:type',
                        name: 'og:type',
                        content: 'website'
                    },
                    {
                        property: 'og:title',
                        name: 'og:title',
                        content: this.metaTitle ? this.metaTitle + ' | Pipe Organ Database' : 'Stoplist Details | Pipe Organ Database'
                    },
                    {
                        property: 'og:description',
                        name: 'og:description',
                        content: 'View This Stoplist'
                    },
                    {
                        property: 'og:image',
                        name: 'og:image',
                        content: 'https://api.pipeorgandatabase.org/uploads/images/blank.png'
                    },
                    {
                        property: 'twitter:card',
                        name: 'twitter:card',
                        content: 'summary'
                    },
                    {
                        property: 'twitter:image',
                        name: 'twitter:image',
                        content: 'https://api.pipeorgandatabase.org/uploads/images/blank.png'
                    },
                    {
                        property: 'twitter:title',
                        name: 'twitter:title',
                        content: this.metaTitle ? this.metaTitle + ' | Pipe Organ Database' : 'Stoplist Details | Pipe Organ Database'
                    },
                    {
                        property: 'twitter:description',
                        name: 'twitter:description',
                        content: 'View This Stoplist'
                    }
                ]
            }
        },
        data() {
            return {
                loading: true,
                stoplist: null,
                stoplistIsText: false,
                textFileContent: '',
                stoplistDivisions: {},
                metaTitle: null,
                divisionPositionTypeOptions: ItemTypes.divisionPositionTypes,
                divisionChestActionTypeOptions: ItemTypes.divisionChestActionTypes,
                divisionStopActionTypeOptions: ItemTypes.divisionStopActionTypes,
            };
        },
        mounted() {
            this.loadInitial(this.$route.params.id);
        },
        methods: {
            toRoman(num) {
                let lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1};
                let roman = '';
                for ( let i in lookup ) {
                    while ( num >= lookup[i] ) {
                    roman += i;
                    num -= lookup[i];
                    }
                }
                return roman;
            },
            loadInitial(id) {
                this.loading = true;
                StoplistService.get(id).then(
                    (response) => {
                        this.stoplist = response.data;

                        if (this.stoplist.type == 0) {
                            this.stoplistDivisions = {};

                            this.stoplist.divisions.sort((a, b) => a.order - b.order).forEach(division => {
                                this.stoplistDivisions[division.name] = division;
                                this.stoplistDivisions[division.name].stops = [];
                                this.stoplistDivisions[division.name].couplers = [];
                            });

                            this.stoplist.stops.sort((a, b) => a.order - b.order).forEach(stopItem => {
                                if (stopItem.from !== null) {
                                    if (stopItem.to in this.stoplistDivisions) {
                                        this.stoplistDivisions[stopItem.to].couplers.push(stopItem);
                                    }
                                } else {
                                    if (stopItem.division in this.stoplistDivisions) {
                                        this.stoplistDivisions[stopItem.division].stops.push(stopItem);
                                    }
                                }
                            });

                            // After pushing the stops and couplers, sort them in order
                            Object.values(this.stoplistDivisions).forEach(division => {
                                division.stops.sort((a, b) => a.order - b.order);
                                division.couplers.sort((a, b) => a.order - b.order);
                            });
                        } else if (this.stoplist.type == 1) {
                            if (this.stoplist.filename && this.stoplist.filename.endsWith('.txt')) {
                                this.stoplistIsText = true;
                                axios.get(this.apiEndpoint + '/uploads/stoplists/' + this.stoplist.filename).then(response => {
                                    this.textFileContent = response.data; // Store the text file content
                                }).catch(error => {
                                    console.error(error);
                                });
                            }
                        }

                        this.metaTitle = "Stoplist Details: ";
                        this.metaTitle += this.stoplist.instruments[0].builder.name;
                        if (this.stoplist.instruments[0].opus) {
                            this.metaTitle += " - Opus " + this.stoplist.instruments[0].opus;
                            if (this.stoplist.instruments[0].year) {
                                this.metaTitle += ",";
                            }
                        }
                        if (this.stoplist.instruments[0].year) {
                            this.metaTitle += " " + this.stoplist.instruments[0].year;
                        }
                        var locationName = this.stoplist.instruments[0].location.name ? this.stoplist.instruments[0].location.name : "Unidentified Location";
                        this.metaTitle += " | " + locationName;
                        if (this.stoplist.instruments[0].location.city || this.stoplist.instruments[0].location.state || this.stoplist.instruments[0].location.country || this.stoplist.instruments[0].location.neighborhood) {
                            this.metaTitle += " -";
                        }
                        if (this.stoplist.instruments[0].location.city && this.stoplist.instruments[0].location.city != "") {
                            this.metaTitle += " " + this.stoplist.instruments[0].location.city;
                            if (this.stoplist.instruments[0].location.neighborhood && this.stoplist.instruments[0].location.neighborhood != "") {
                                this.metaTitle += " (" + this.stoplist.instruments[0].location.neighborhood + "), ";
                            } else {
                                this.metaTitle += ", ";
                            }
                        } else if (this.stoplist.instruments[0].location.neighborhood && this.stoplist.instruments[0].location.neighborhood != "") {
                            this.metaTitle += " " + this.stoplist.instruments[0].location.neighborhood + ", ";
                        }
                        if (this.stoplist.instruments[0].location.state) {
                            this.metaTitle += " " + this.stoplist.instruments[0].location.state + ", ";
                        }
                        if (this.stoplist.instruments[0].location.country && this.stoplist.instruments[0].location.country != "") {
                            this.metaTitle += " " + this.stoplist.instruments[0].location.country;
                        }
                        this.metaTitle = this.metaTitle.replace(/ ,/g, ',').trim();

                        this.loading = false;
                    },
                    (error) => {
                        console.log(error);
                        this.stoplistDivisions = {};
                        if (error.response && error.response.status) {
                            this.$router.push("/" + error.response.status);
                        }
                    }
                );
            },
            getDate(date) {
                if (date) {
                    return moment(date).format("MMMM Do, YYYY");
                }
                return "";
            },
        },
    };
</script>